import { DataBean } from "../DataBean";

export class DocumentHeaderByProcess extends DataBean {

    public async getDocumentHeaderByProcess(idProcess: any, year: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentHeaderByProcess_Number_Number", [idProcess, year]);
    }

}